"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContainerHandlerIndex_1 = require("../containerhandler/ContainerHandlerIndex");

var ContainerHandlerLanguage_1 = require("../containerhandler/ContainerHandlerLanguage");

var Util_1 = require("../Util");
/**
 * Handles values that are part of a container type (like @index),
 * as specified by {@link IContainerHandler}.
 */


var EntryHandlerContainer =
/*#__PURE__*/
function () {
  function EntryHandlerContainer() {
    _classCallCheck(this, EntryHandlerContainer);
  }

  _createClass(EntryHandlerContainer, [{
    key: "isPropertyHandler",
    value: function isPropertyHandler() {
      return false;
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, keys, depth, inProperty) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.test(parsingContext, util, null, keys, depth);

              case 2:
                return _context.abrupt("return", !!_context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate(_x, _x2, _x3, _x4, _x5) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(parsingContext, util, key, keys, depth) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = Util_1.Util;
                _context2.next = 3;
                return parsingContext.getContext(keys);

              case 3:
                _context2.t1 = _context2.sent;
                _context2.t2 = keys[depth - 1];
                _context2.t3 = _context2.t0.getContextValueContainer.call(_context2.t0, _context2.t1, _context2.t2);
                return _context2.abrupt("return", EntryHandlerContainer.CONTAINER_HANDLERS[_context2.t3]);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function test(_x6, _x7, _x8, _x9, _x10) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(parsingContext, util, key, keys, value, depth, testResult) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                parsingContext.emittedStack[depth] = false; // We will emit a level higher

                return _context3.abrupt("return", testResult.handle(parsingContext, keys, value, depth));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function handle(_x11, _x12, _x13, _x14, _x15, _x16, _x17) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerContainer;
}();

EntryHandlerContainer.CONTAINER_HANDLERS = {
  '@index': new ContainerHandlerIndex_1.ContainerHandlerIndex(),
  '@language': new ContainerHandlerLanguage_1.ContainerHandlerLanguage()
};
exports.EntryHandlerContainer = EntryHandlerContainer;